export default {
    helpInfo: 'try clearing the browser cache by pressing Ctrl+F5, then exit and log in to CRM. ' +
        'If it doesn\'t help, describe the problem in an email and send it to _support_CRM@fix-price.ru',
    '403': 'Access denied',
    '404': 'Information not found',
    '500': 'Internal server error',
    incorrectData: 'Incorrect data',
    orderChangeStatus: 'Failed to change order status',
    unknownError: 'Unknown error',
    notGetFile: 'Failed to retrieve file',
    'default': 'Unknown error',
    failedToUpdateTheStamps: 'Не удалось обновить данные о марках в заказе!',
};